module.exports = __webpack_public_path__ + "img/ring_r_0_1_null@2x.70cb8fd8.png";